<template>
  <v-container>
    <v-btn color="primary" :to="{ name: 'AdminUserCreate' }" router> Create User </v-btn>

    <v-divider class="my-4"></v-divider>

    <!-- Data Table -->
    <v-data-table-server
      v-model:items-per-page="pagination.limit"
      :items="users"
      :items-length="count"
      :loading="loading"
      :headers="headers"
      :search="pagination.q"
      item-key="id"
      class="elevation-1"
      @update:options="handleLimitChange">
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          :to="{ name: 'AdminUserEditDetail', params: { id: item.id } }"
          router
          size="small"
          color="primary">
          Edit
        </v-btn>
      </template>
      <template v-slot:top>
        <v-text-field
          v-model="pagination.q"
          class="ma-2"
          density="compact"
          placeholder="Search users..."
          hide-details></v-text-field>
      </template>
    </v-data-table-server>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { IPaginationDTO, PaginationDTO } from '@/dtos';
import type { VDataTableServer } from 'vuetify/components';
import { useUserStore } from '@/stores/modules/';

const pagination = ref<IPaginationDTO>(new PaginationDTO());
const userStore = useUserStore();
const users = computed(() => userStore.getAllUsersQuery.data?.data);
const count = computed(() => userStore.getAllUsersQuery.data?.count ?? 0);
const loading = computed(() => userStore.getAllUsersQuery.isLoading);

const headers = [
  { title: 'First Name', key: 'first_name' },
  { title: 'Last Name', key: 'last_name' },
  { title: 'Email', key: 'email_address' },
  { title: 'Role', key: 'role.role_name', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false },
];

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
  userStore.pagination = pagination.value;
};
</script>

<style scoped></style>
